'use strict';

var React = require('react'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    ClassNameMixin = require('../mixins/ClassNameMixin'),
    { PropTypes } = React;

var Container = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    overlay: PropTypes.bool
  },

  className: 'PageControls-container',

  getCSSModifiers() {
    return [
      this.props.fill && 'fill',
    ];
  },

  render: function () {
    return (
      <div className={this.getClassName()}>
        {this.props.children}
      </div>
    );
  }
});

require('./PageControls.less');

var Separator = React.createClass({
  mixins: [PureRenderMixin],

  statics: {
    IS_SEPARATOR: true
  },

  render: function () {
    return (
      <div className='PageControls-separator' />
    );
  }
});

var Message = React.createClass({
  mixins: [PureRenderMixin],

  render: function () {
    return (
      <div className='PageControls-message'>
        {this.props.children}
      </div>
    );
  }
});

var PageControls = React.createClass({
  mixins: [ClassNameMixin, PureRenderMixin],

  propTypes: {
    overlay: PropTypes.bool,
    color: PropTypes.oneOf(['dark', 'light'])
  },

  getDefaultProps() {
    return {
      color: 'dark'
    };
  },

  getCSSModifiers() {
    return [
      this.props.center && 'center',
      this.props.spaceBetween && 'spaceBetween',
      this.props.color
    ];
  },

  render: function () {
    return (
      <div className={this.getClassName()}>
        {React.Children.map(this.props.children, this.renderAction)}
      </div>
    );
  },

  renderAction: function (item) {
    if (!item) {
      return;
    }

    if (item.type.IS_SEPARATOR) {
      return item;
    }

    return (
      {item}
    );
  }
});

module.exports = PageControls;
module.exports.Container = Container;
module.exports.Separator = Separator;
module.exports.Message = Message;



/** WEBPACK FOOTER **
 ** ./molecules/PageControls.jsx
 **/